export default defineNuxtRouteMiddleware((to, _) => {
  const router = useRouter();
  const route = router.resolve(to.path);
  const isRouteMatched = route.matched.length > 0;

  if (!isRouteMatched) {
    return '/';
  }
});
